"use client";

import { Briefcase, Target, Users, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function SolutionsForYourBusinessNeeds() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const solutions = [{
    icon: Target,
    label: "ATTRACT",
    description: "Attract managers who share your values and have the capabilities to drive quality and excellence in care.",
    colorScheme: "primary"
  }, {
    icon: Users,
    label: "ASSESS",
    description: "Assess core management skills and pinpoint development steps with 'Care Character Advance'.",
    colorScheme: "secondary"
  }, {
    icon: Briefcase,
    label: "SUPPORT",
    description: "Provide managers with the tools to recruit effectively and create teams that thrive long term.",
    colorScheme: "accent"
  }, {
    icon: Shield,
    label: "RETAIN",
    description: "Support manager success with person-centred retention interviews at key points in the journey.",
    colorScheme: "primary"
  }];
  const getIconBackground = (scheme: string) => {
    switch (scheme) {
      case "secondary":
        return "bg-secondary/15 text-secondary";
      case "accent":
        return "bg-accent/15 text-accent";
      default:
        return "bg-primary/15 text-primary";
    }
  };
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-3xl font-bold text-center text-foreground mb-12 lg:text-4xl">
          Solutions for Care Providers
        </h2>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <Card key={i} data-index={i} className={`
                  card relative z-10
                  ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
                `} style={{
            transitionDelay: isVisible ? `${i * 150}ms` : "0ms"
          }}>
                <CardContent className="flex flex-col items-center text-center gap-4">
                  <div className={`flex h-16 w-16 items-center justify-center rounded-full ${getIconBackground(solution.colorScheme)}`}>
                    <Icon className="h-8 w-8" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-foreground">
                    {solution.label}
                  </h3>
                  <p className={`text-sm leading-relaxed ${i === 0 ? "text-foreground" : i === 1 ? "text-black" : i === 2 ? "text-black" : i === 3 ? "text-black" : "text-muted-foreground"}`}>
                    {solution.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}